import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { providePendingCredentialCleanup } from './auth/commands/pending-credential';
import { provideDeviceTracking } from './devices/data/device-tracking';
import { GlobalErrorHandler } from './errors/global-error-handler';
import { provideFirebase } from './firebase/providers';
import { Theme } from './theme/theme';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions()),
    provideFirebase(),
    provideDeviceTracking(),
    provideHttpClient(),
    provideEnvironmentInitializer(() => inject(Theme)),
    providePendingCredentialCleanup(),
  ],
};
